import * as React from "react";
export class Button extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = typeof props.onClick === "function" ? props.onClick.bind(props.context) : this.noop;
        this.element = React.createRef();
        this.focus = props.focus ? true : false;
        // tslint:disable-next-line
        this.timeout = null;
    }
    setFocus() {
        if (this.element.current !== null) {
            this.element.current.focus();
        }
    }
    componentDidMount() {
        if (this.focus === true) {
            this.timeout = setTimeout(this.setFocus.bind(this), 10);
        }
    }
    noop() { }
    render() {
        return (React.createElement("button", { type: "button", className: `rj-dialog-message__button ${this.props.classes || ""}`, ref: this.element, onClick: this.onClick, "data-uat": this.props.uat }, this.props.text));
    }
}
//# sourceMappingURL=Button.js.map